import React from 'react'
import MaterialSymbol from '../material-symbol'

const TrendingDown = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="trending_down" {...props} />
))

TrendingDown.displayName = 'TrendingDown'

export default TrendingDown
